import React, { FC, ReactElement } from 'react'
import styles from './Seed.module.css'
import classNames from 'classnames'
import CopyButton from '@/components/copy-button'

const Seed: FC<{ seed: string }> = (props): ReactElement => {
	const words = React.useMemo(() => props.seed.split(' '), [props.seed])

	const renderWord = React.useCallback((word: any, i: any) => {
		return (
			<div className={styles.word} key={i}>
				<p className={classNames(styles.wordNumber, 'text-md', 'regular')}>{i + 1}</p>
				<p data-testid={`seed-word-${i + 1}`} className={classNames(styles.wordLabel, 'text-md', 'regular')}>{word}</p>
			</div>
		)
	}, [])

	return (
		<div className={styles.root}>
			<div translate="no" className={styles.grid}>{words.map(renderWord)}</div>
			<CopyButton className={styles.copyButton} label="Copy to clipboard" value={props.seed} />
		</div>
	)
}

export default Seed
